import React from 'react';
import { useId } from '@reach/auto-id';

import { useField, useFieldDescription } from '../../context/form.context';
import { LabeledCheckboxRadioInput } from '../checkbox-radio-input';
import { ErrorMessage } from '../error-message.component';

export type CheckboxFieldProps = {
  name: string;
  label?: string;
  className?: string;
  id?: string;
};

export const CheckboxField = ({
  name,
  label: labelProp,
  className,
  id,
}: CheckboxFieldProps) => {
  const [field, meta] = useField({ name, type: 'checkbox' });
  const { fieldLabel } = useFieldDescription(name);
  const label = labelProp ?? fieldLabel;
  const { error, touched } = meta;
  const hasError = Boolean(error && touched);
  const inputId = useId(id)!;
  const errorId = useId()!;

  return (
    <div className={className}>
      <LabeledCheckboxRadioInput
        type="checkbox"
        label={label}
        id={inputId}
        hasError={hasError}
        aria-describedby={hasError ? errorId : undefined}
        {...field}
      />
      {hasError && <ErrorMessage id={errorId}>{error}</ErrorMessage>}
    </div>
  );
};
